import React from 'react';
import BaseChart from './BaseChart';
import { ChartType } from './BaseChart';

export interface SalesChartProps {
  data: {
    labels: string[];
    values: number[];
  };
  title: string;
  options?: any;
  type?: ChartType;
}

const SalesChart: React.FC<SalesChartProps> = ({ data, title, options = {}, type = 'line' }) => {
  const chartData = {
    labels: data.labels,
    datasets: [
      {
        label: title,
        data: data.values,
        borderColor: 'rgb(75, 192, 192)',
        backgroundColor: 'rgba(75, 192, 192, 0.5)',
      },
    ],
  };

  const defaultOptions = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top' as const,
      },
      title: {
        display: true,
        text: title,
      },
    },
    ...options,
  };

  return (
    <BaseChart
      type={type}
      data={chartData}
      title={title}
      height={300}
      width={800}
      options={defaultOptions}
    />
  );
};

export default SalesChart; 